import { Input, InputProps } from '@chakra-ui/react'

type AppTimeSelectProps = InputProps

const AppSelectTime = ({ ...other }: AppTimeSelectProps) => (
  <Input type="time" {...other} />
)

export default AppSelectTime
